import styled, { css } from "styled-components";

import { colors, typography } from "@/styles/variables";

export const Label = styled.div`
  font: ${typography.fontSizeDefault} ${typography.fontFamilyDefault};
  line-height: 22px;
`;

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  fullWidth?: boolean;
  readonly?: boolean;
}

export const Input = styled.input<InputProps>`
  background: transparent;

  ${({ readonly }) =>
    readonly
      ? css`
          border: none;
          padding: 0;
        `
      : css`
          border: 1.5px solid #e0e0e0;
          border-radius: 2px;
          padding: 0 1rem;
          height: 3rem;
        `}

  &:focus {
    border-color: ${colors.inputActiveColor};
    outline: none;
  }

  ${({ fullWidth }) =>
    fullWidth &&
    css`
      width: 100%;
    `}
`;

export const HelperText = styled.div`
  font: ${typography.fontSizeDefault} ${typography.fontFamilyDefault};
  line-height: 22px;
`;

interface ContainerProps {
  error?: boolean;
}

export const Container = styled.label<ContainerProps>`
  &:focus-within {
    ${Label} {
      color: ${colors.inputActiveColor};
    }
  }

  ${(props) =>
    props.error &&
    css`
      ${Label} {
        color: ${colors.errorColor};
      }

      ${Input} {
        border-color: ${colors.errorColor};
      }
    `}
`;
